import { fromJS } from 'immutable';
import { PROPERTY_DATA_KV_MAP } from '@/constants';

const {
  residentialType,
  addressIdentification,
  strLicense,
  locationType,
  // rentalType,
  rentalStructure,
  onlinePlatforms,
  unitType,
  activity,
  visibility,
  complaints,
} = PROPERTY_DATA_KV_MAP;

export const initFilterParams = fromJS({
  residentialType: {
    [residentialType.primary]: false,
    [residentialType.secondaryInvestment]: false,
    [residentialType.unknown]: false,
  },
  addressIdentification: {
    [addressIdentification.identifiedListing]: false,
    [addressIdentification.unidentifiedListing]: false,
    [addressIdentification.liveListing]: false,
    [addressIdentification.nonLiveListing]: false,
    [addressIdentification.recentLiveListing]: false,
  },
  strLicense: {
    [strLicense.hasStrLicense]: false,
    [strLicense.hasNoStrLicense]: false,
  },
  locationType: {
    [locationType.within]: false,
    [locationType.selfReported]: false,
    [locationType.neighboring]: false,
  },
  unitType: {
    [unitType.selfContained]: false,
    [unitType.room]: false,
    [unitType.unknown]: false,
    [unitType.other]: false,
  },
  rentalStructure: {
    [rentalStructure.mainStructure]: false,
    [rentalStructure.adu]: false,
    [rentalStructure.multiFamily]: false,
    [rentalStructure.unknown]: false,
  },
  onlinePlatforms: {},
  occupancy: {
    numberValue: 0,
    withUnknown: false,
  },
  hoa: [],
  rentalType: {}, // these are set dynamically
  activity: {
    [activity.hasBookings]: false,
    [activity.hasAvailability]: false,
    [activity.isBlocked]: false,
  },
  visibility: {
    [visibility.liveNow]: false,
    [visibility.notLive]: false,
    [visibility.liveRecently]: false,
  },
  complaints: {
    [complaints.hasOpenComplaints]: false,
    [complaints.hasClosedComplaints]: false,
  },
});
